/**
 * Contextual repair coach-mark: damaged flask on Merge, once, if the player can pay.
 */

/**
 * @param {object} state
 * @param {boolean} state.dismissed
 * @param {boolean} state.inShake
 * @param {boolean} state.minimizeMode
 * @param {boolean} state.blocked
 * @param {boolean} state.damaged
 * @param {boolean} state.canAfford
 * @param {boolean} state.healVisible
 * @returns {boolean}
 */
export function shouldShowHealHint(state) {
  var s = state || {};
  if (s.dismissed) return false;
  if (!s.inShake) return false;
  if (s.minimizeMode) return false;
  if (s.blocked) return false;
  if (!s.damaged) return false;
  if (!s.canAfford) return false;
  if (!s.healVisible) return false;
  return true;
}
